import { render, staticRenderFns } from "./Posterslides.vue?vue&type=template&id=9cd4be56"
import script from "./Posterslides.vue?vue&type=script&lang=js"
export * from "./Posterslides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports